<mat-card class="card-style px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Criar tarifário</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  @if (mostrarInfoEspelhamento) {
    <div class="mirror-info mt-3">
      <mat-icon>info</mat-icon>
      <span>
        Este tarifário será <strong>espelhado automaticamente</strong>. Ao
        criar, um segundo tarifário será gerado invertendo apenas a ordem de
        origem/destino.
      </span>
    </div>
  }

  <div [formGroup]="form" class="mt-4 container mx-auto">
    <!--    <div class="flex justify-between items-center mt-3 -mx-2">-->
    <!--      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">-->
    <!--        <mat-label>Tipo tarifário</mat-label>-->
    <!--        <mat-select formControlName="tariffType" (selectionChange)="onSelectionChangeTypeTarrif($event)">-->
    <!--          @for (type of listTypeTariff; track type) {-->
    <!--          <mat-option [value]="type.id">{{ type.descricao }}</mat-option>-->
    <!--          }-->
    <!--        </mat-select>-->
    <!--      </mat-form-field>-->
    <!--      <mat-form-field class="input-tg w-9/12 px-2" appearance="outline">-->
    <!--        <mat-label>Cliente</mat-label>-->
    <!--        <input matInput formControlName="client" readonly />-->
    <!--        @if (this.form.get('client')!.enabled) {-->
    <!--        <button mat-icon-button matSuffix (click)="addClient()">-->
    <!--          <mat-icon>add</mat-icon>-->
    <!--        </button>-->
    <!--        }-->
    <!--      </mat-form-field>-->
    <!--      &lt;!&ndash;      <mat-slide-toggle&ndash;&gt;-->
    <!--      &lt;!&ndash;        class="input-tg w-1/12 p-bottom-toggle px-2"&ndash;&gt;-->
    <!--      &lt;!&ndash;        formControlName="active"&ndash;&gt;-->
    <!--      &lt;!&ndash;        >{{ form.get('active')?.value ? 'Ativo' : 'Inativo' }}</mat-slide-toggle&ndash;&gt;-->
    <!--      &lt;!&ndash;      >&ndash;&gt;-->
    <!--    </div>-->

    <!--    <div class="flex justify-between items-center mt-3 -mx-2">-->
    <!--      <mat-form-field class="input-tg w-full px-2" appearance="outline">-->
    <!--        <mat-label>Fornecedor</mat-label>-->
    <!--        <input matInput formControlName="supplier" readonly />-->
    <!--        <button mat-icon-button matSuffix (click)="addSupplier()">-->
    <!--          <mat-icon>add</mat-icon>-->
    <!--        </button>-->
    <!--      </mat-form-field>-->
    <!--    </div>-->

    <div class="flex justify-start items-center mt-3 -mx-2">
      <mat-form-field class="input-tg w-4/12 px-2" appearance="outline">
        <mat-label>Tipo Tarifário</mat-label>
        <input
          matInput
          type="text"
          formControlName="tariffType"
          [matAutocomplete]="autoTariffType"
        />
        <mat-autocomplete
          #autoTariffType="matAutocomplete"
          [displayWith]="displayTariffType"
          autoActiveFirstOption
          (optionSelected)="selectTypeTariff($event.option.value)"
        >
          <mat-option
            *ngFor="let type of filteredTariffTypes | async"
            [value]="type.id"
          >
            {{ type.descricao }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field class="input-tg w-4/12 px-2" appearance="outline">
        <mat-label>Exclusivo do Cliente</mat-label>
        <mat-select formControlName="exclusiveCustomer">
            <mat-option value="N">Não</mat-option>
            <mat-option value="S">Sim</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
      <div class="flex justify-between items-center mt-3 -mx-2">
      <mat-form-field class="input-tg w-4/12 px-2" appearance="outline">
        <mat-label>Origem</mat-label>
        <input matInput formControlName="origin" />
      </mat-form-field>
      <!--      <mat-form-field appearance="outline" class="input-tg w-4/12 px-2">-->
      <!--        <mat-label>Origem</mat-label>-->

      <!--        <input-->
      <!--          matInput-->
      <!--          type="text"-->
      <!--          formControlName="origin"-->
      <!--          [matAutocomplete]="autoOrigin"-->
      <!--        />-->

      <!--        <mat-autocomplete-->
      <!--          #autoOrigin="matAutocomplete"-->
      <!--          [displayWith]="displayLocation"-->
      <!--          autoActiveFirstOption-->
      <!--        >-->
      <!--          <mat-option *ngFor="let opt of filteredOrigins | async" [value]="opt">-->
      <!--            {{ opt.descricao }}-->
      <!--          </mat-option>-->
      <!--        </mat-autocomplete>-->
      <!--      </mat-form-field>-->
      <mat-form-field class="input-tg w-4/12 px-2" appearance="outline">
        <mat-label>Destino</mat-label>
        <input matInput formControlName="destination" />
      </mat-form-field>
      <!--      <mat-form-field class="input-tg w-4/12 px-2" appearance="outline">-->
      <!--        <mat-label>Destino</mat-label>-->
      <!--        <input-->
      <!--          matInput-->
      <!--          type="text"-->
      <!--          formControlName="destination"-->
      <!--          [matAutocomplete]="autoDestination"-->
      <!--        />-->

      <!--        <mat-autocomplete-->
      <!--          #autoDestination="matAutocomplete"-->
      <!--          [displayWith]="displayLocation"-->
      <!--          autoActiveFirstOption-->
      <!--        >-->
      <!--          <mat-option-->
      <!--            *ngFor="let opt of filteredDestinations | async"-->
      <!--            [value]="opt"-->
      <!--          >-->
      <!--            {{ opt.descricao }}-->
      <!--          </mat-option>-->
      <!--        </mat-autocomplete>-->
      <!--      </mat-form-field>-->
      <mat-slide-toggle
        class="input-tg w-4/12 p-bottom-toggle px-2"
        formControlName="urbanPerimeter"
        >Perimetro urbano:
        <strong>{{
          form.get('urbanPerimeter')?.value ? 'dentro' : 'fora'
        }}</strong></mat-slide-toggle
      >
      <!--      <mat-slide-toggle-->
      <!--        class="input-tg w-3/12 p-bottom-toggle px-2"-->
      <!--        formControlName="standard"-->
      <!--        >Standard:-->
      <!--        <strong>{{-->
      <!--          form.get('standard')?.value ? 'sim' : 'não'-->
      <!--        }}</strong></mat-slide-toggle-->
      <!--      >-->
    </div>

    <div class="flex justify-between items-center mt-3 -mx-2">
      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
        <mat-label>Tipo Serviço</mat-label>
        <input matInput formControlName="serviceType" />
      </mat-form-field>
      <!--      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">-->
      <!--        <mat-label>Tipo Serviço</mat-label>-->
      <!--        <mat-select-->
      <!--          formControlName="serviceType"-->
      <!--          (selectionChange)="onSelectionChangeServiceSpecification($event)"-->
      <!--        >-->
      <!--          @for (type of listTypeService; track type) {-->
      <!--            <mat-option [value]="type.id">{{ type.descricao }}</mat-option>-->
      <!--          }-->
      <!--        </mat-select>-->
      <!--      </mat-form-field>-->
      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
        <mat-label>Serviço</mat-label>
        <input matInput formControlName="specificationService" />
      </mat-form-field>
      <!--      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">-->
      <!--        <mat-label>Serviço</mat-label>-->
      <!--        <mat-select-->
      <!--          formControlName="specificationService"-->
      <!--          (selectionChange)="onSelectionChangeService($event)"-->
      <!--        >-->
      <!--          @if (listServiceSpecification.length == 0) {-->
      <!--            <mat-option disabled>Nenhum registro.</mat-option>-->
      <!--          } @else {-->
      <!--            @for (type of listServiceSpecification; track type) {-->
      <!--              <mat-option [value]="type.id">{{ type.descricao }}</mat-option>-->
      <!--            }-->
      <!--          }-->
      <!--        </mat-select>-->
      <!--      </mat-form-field>-->
      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
        <mat-label>Tipo veículo</mat-label>
        <input matInput formControlName="vehicleType" />
      </mat-form-field>
      <!--      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">-->
      <!--        <mat-label>Tipo veículo</mat-label>-->
      <!--        <mat-select formControlName="vehicleType">-->
      <!--          @for (type of listTypeVehicle; track type) {-->
      <!--            <mat-option [value]="type.id">{{ type.descricao }}</mat-option>-->
      <!--          }-->
      <!--        </mat-select>-->
      <!--      </mat-form-field>-->
      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
        <mat-label>Tipo motorista</mat-label>
        <input matInput formControlName="driverType" />
      </mat-form-field>
      <!--      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">-->
      <!--        <mat-label>Tipo motorista</mat-label>-->
      <!--        <mat-select formControlName="driverType">-->
      <!--          @for (type of listTypeDriver; track type) {-->
      <!--            <mat-option [value]="type.id">{{ type.descricao }}</mat-option>-->
      <!--          }-->
      <!--        </mat-select>-->
      <!--      </mat-form-field>-->
    </div>

    <div class="flex justify-between items-center mt-3 -mx-2">
      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
        <mat-label>Valor custo</mat-label>
        @if (form.get('cost')!.value != '') {
          <span matTextPrefix>R$&nbsp;</span>
        }
        <input matInput formControlName="cost" currencyInput />
      </mat-form-field>

      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
        <mat-label>Custo hora extra</mat-label>
        @if (form.get('costOvertime')!.value != '') {
          <span matTextPrefix>R$&nbsp;</span>
        }
        <input matInput formControlName="costOvertime" currencyInput />
      </mat-form-field>

      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
        <mat-label>Custo Km extra</mat-label>
        @if (form.get('costKmExtra')!.value != '') {
          <span matTextPrefix>R$&nbsp;</span>
        }
        <input matInput formControlName="costKmExtra" currencyInput />
      </mat-form-field>

      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
        <mat-label>Validade</mat-label>
        <input
          matInput
          [matDatepicker]="validity"
          (focus)="openDatepicker()"
          formControlName="validity"
          readonly
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="validity"
        ></mat-datepicker-toggle>
        <mat-datepicker #validity></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
  <div class="flex justify-end">
    <button
      mat-flat-button
      class="btn-tg w-1/5"
      [disabled]="!checkForm() || loading"
      (click)="editTariff()"
    >
      @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
        Criar
      }
    </button>
  </div>
</mat-card>
